export const COOKIE_MAX_AGE_ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;

export const getCookieValue = (cookieKey: string): string | undefined => {
  if (typeof document === 'undefined') return undefined;

  const rawValue = document.cookie
    .split('; ')
    .find(cookieEntry => cookieEntry.startsWith(`${encodeURIComponent(cookieKey)}=`))
    ?.split('=')[1];

  return rawValue === undefined ? undefined : decodeURIComponent(rawValue);
};

export const setCookieValue = (cookieKey: string, value: string): void => {
  if (typeof document === 'undefined') return;

  document.cookie = `${encodeURIComponent(cookieKey)}=${encodeURIComponent(value)}; path=/; max-age=${COOKIE_MAX_AGE_ONE_YEAR_SECONDS}; samesite=lax`;
};

/** No max-age, so the browser clears it when the session ends (browser closes). */
export const setSessionCookieValue = (cookieKey: string, value: string): void => {
  if (typeof document === 'undefined') return;

  document.cookie = `${encodeURIComponent(cookieKey)}=${encodeURIComponent(value)}; path=/; samesite=lax`;
};

export const deleteCookieValue = (cookieKey: string): void => {
  if (typeof document === 'undefined') return;

  document.cookie = `${encodeURIComponent(cookieKey)}=; path=/; max-age=0; samesite=lax`;
};
